export function renderHelpModal(title: string, body: string, open: boolean): string {
  return `
    <div class="help-modal ${open ? "is-open" : ""}" aria-hidden="${open ? "false" : "true"}">
      <div class="help-dialog" role="dialog" aria-modal="true" aria-label="${title}">
        <div class="help-dialog-head">
          <h2>${title}</h2>
          <button type="button" class="help-close" data-action="close-help" aria-label="Close computation details">Close</button>
        </div>
        <div class="help-dialog-body">
          ${body}
        </div>
      </div>
    </div>
  `;
}
